import React, { FunctionComponent } from 'react';
import { StepEnum } from 'api/models';
import { assertUnreachable } from 'ui/helper/unreachable';
import OfferStep from 'subapps/investment/pages/investment/wizard-steps/offer';
import QuestionnaireStep from 'subapps/investment/pages/investment/wizard-steps/questionnaire';
import VibStep from 'subapps/investment/pages/investment/wizard-steps/vib';
import BeneficiaryStep from 'subapps/investment/pages/investment/wizard-steps/beneficiary';
import IdentificationStep from 'subapps/investment/pages/investment/wizard-steps/identification-step';
import SummaryStep from 'subapps/investment/pages/investment/wizard-steps/summary';
import SelectWalletStep from 'subapps/investment/pages/investment/wizard-steps/wallet/select-wallet';
import AccountSetupStep from 'subapps/investment/pages/investment/wizard-steps/account-setup';
import UseConfirmationStep from 'subapps/investment/pages/investment/wizard-steps/user-confirmation';
import FinalStep from 'subapps/investment/pages/investment/wizard-steps/final';
import AdditionalInformationStep from 'subapps/investment/pages/investment/wizard-steps/additional-information';
import InvestmentAmountStep from 'subapps/investment/pages/investment/wizard-steps/investment-amount';
import TaxInformationStep from 'subapps/investment/pages/investment/wizard-steps/tax-information';
import SetupMobileWalletStep from 'subapps/investment/pages/investment/wizard-steps/wallet/setup-mobile-wallet';
import ConfirmWalletStep from 'subapps/investment/pages/investment/wizard-steps/wallet/confirm';
import WalletStepDone from 'subapps/investment/pages/investment/wizard-steps/wallet/wallet-step-done';
import IdentificationStepDone from 'libraries/wizard/components/identification-step-done';
import PrepareAssetStep from 'subapps/investment/pages/investment/wizard-steps/wallet/prepare-asset';

const stepMapping = (
  step?: StepEnum,
): {
  Component: FunctionComponent<any>;
  DoneComponent?: FunctionComponent<any>;
  investmentRequired?: boolean;
} => {
  switch (step) {
    case StepEnum.ACCOUNT_SETUP:
      return {
        Component: AccountSetupStep,
        investmentRequired: false,
      };
    case StepEnum.UNCONFIRMED:
      return {
        Component: UseConfirmationStep,
        investmentRequired: false,
      };
    case StepEnum.INVESTMENT_AMOUNT:
      return {
        Component: InvestmentAmountStep,
        investmentRequired: false,
      };
    case StepEnum.QUESTIONNAIRE:
      return {
        Component: QuestionnaireStep,
        investmentRequired: false,
      };
    case StepEnum.VIB:
      return {
        Component: VibStep,
        investmentRequired: false,
      };
    case StepEnum.OFFER_CREATION:
      return {
        Component: OfferStep,
        investmentRequired: false,
      };
    case StepEnum.BENEFICIARY:
      return {
        Component: BeneficiaryStep,
      };
    case StepEnum.IDENTIFICATION:
    case StepEnum.RESUME_IDENTIFICATION:
    case StepEnum.IDENTIFICATION_FAILED:
    case StepEnum.IDENTIFICATION_REJECTED:
      return {
        Component: IdentificationStep,
        DoneComponent: IdentificationStepDone,
      };
    case StepEnum.WAITING_KYC:
      return {
        Component: SummaryStep,
      };
    case StepEnum.WAITING_ACCEPTANCE:
    case StepEnum.WAITING_COMPLIANCE:
    case StepEnum.PAYMENT:
      return {
        Component: SummaryStep,
      };
    case StepEnum.TAX_INFORMATION:
      return {
        Component: TaxInformationStep,
      };
    case StepEnum.SELECT_WALLET:
      return {
        Component: SelectWalletStep,
        DoneComponent: WalletStepDone,
      };
    case StepEnum.SETUP_MOBILE_WALLET:
      return {
        Component: SetupMobileWalletStep,
      };
    case StepEnum.PREPARE_ASSET:
      return {
        Component: PrepareAssetStep,
      };
    case StepEnum.CONFIRM_WALLET:
      return {
        Component: ConfirmWalletStep,
      };
    case StepEnum.ADDITIONAL_INFORMATION:
      return {
        Component: AdditionalInformationStep,
      };
    case StepEnum.FINAL:
      return {
        Component: FinalStep,
      };
    case StepEnum.CANCELED:
    case undefined:
      return {
        Component: () => <></>,
        investmentRequired: false,
      };
  }

  return assertUnreachable(step);
};

export default stepMapping;
